import { createFileRoute } from '@tanstack/react-router';
import { CmsPageRenderer } from '@pages/cms-page';

/** Route für die Galerie-Seite (/galerie). Lädt CMS-Inhalte für Slug "galerie". */
export const Route = createFileRoute('/galerie')({
  component: function GalerieRoute() {
    return <CmsPageRenderer slug="galerie" />;
  },
});
